module.exports = __webpack_public_path__ + "img/p34.a75fb473.png";